import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    textAlign: "center",
    padding: "2rem",
  },
  headerText: {
    fontSize: "2rem",
    fontWeight: "bold",
    marginBottom: "1rem",
    color: "#FF68D5",
  },
  description: {
    fontSize: "1.2rem",
    marginBottom: "1rem",
    color: "#555",
  },
  home: {
    cursor: "pointer",
    "&:hover": {
      textDecoration: "underline",
      color: "#0095F6",
    },
  },
}));

export default useStyles;
